<div class="tab-content-pad">
    <div class="detail-card" *ngIf="output[0]">

        <!-- Card Header: avatar + name + edit button -->
        <div class="detail-card-header">
            <div class="employee-identity">
                <div class="employee-avatar">
                    <img [src]="imgUrl" alt="" style="width:100%;height:100%;object-fit:cover;border-radius:8px;"
                        (error)="imgError = true" *ngIf="!imgError">
                    <i class="fas fa-user-circle" *ngIf="imgError" style="font-size: 2.4rem; color: #2e7d32;"></i>
                </div>
                <div>
                    <p class="employee-name">{{ name }}</p>
                    <span class="employee-role-badge">{{ output[0]?.role || 'User' }}</span>
                </div>
            </div>
            <a class="btn-edit" routerLink="/admin/edit-user" [queryParams]="{id: editUserId}">
                <i class="fas fa-pencil-alt"></i> Edit
            </a>
        </div>

        <!-- Two-column fields grid -->
        <div class="detail-fields-grid">

            <div class="detail-field-item">
                <span class="field-label">Department</span>
                <span class="field-value" [class.empty]="!output[0]?.department">
                    {{ output[0]?.department || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Role</span>
                <span class="field-value" [class.empty]="!output[0]?.role">
                    {{ output[0]?.role || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Brand</span>
                <span class="field-value" [class.empty]="!output[0]?.employee_brand">
                    {{ output[0]?.employee_brand || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Mobile</span>
                <span class="field-value" [class.empty]="!output[0]?.mobile">
                    {{ output[0]?.mobile || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Check-in Time</span>
                <span class="field-value" [class.empty]="!check_in">
                    {{ (DateFormat1(check_in) | date) || '—' }}
                    {{ check_in ? (DateFormat1(check_in) | date: ' hh:mm a') : '' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Check-out Time</span>
                <span class="field-value" [class.empty]="!check_out">
                    {{ (DateFormat1(check_out) | date) || '—' }}
                    {{ check_out ? (DateFormat1(check_out) | date: ' hh:mm a') : '' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">App Version</span>
                <span class="field-value" [class.empty]="!app_version">
                    {{ app_version || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">User Type</span>
                <span class="field-value" [class.empty]="!userTypeDetails?.name">
                    {{ userTypeDetails?.name || 'Not assigned' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Work In Time</span>
                <span class="field-value" [class.empty]="!output1[0]?.workin_time">
                    {{ output1[0]?.workin_time || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Work Out Time</span>
                <span class="field-value" [class.empty]="!output1[0]?.workout_time">
                    {{ output1[0]?.workout_time || '—' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Department Specific</span>
                <span class="field-value">
                    {{ output1[0]?.is_department_specific ? 'Yes' : 'No' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Location Restricted</span>
                <span class="field-value">
                    {{ output1[0]?.is_location_restricted ? 'Yes' : 'No' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Is Visit Location Restricted</span>
                <span class="field-value">
                    {{ output1[0]?.is_visit_location_restricted ? 'Yes' : 'No' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Customer Location Enabled</span>
                <span class="field-value">
                    {{ output1[0]?.is_customer_location_enabled ? 'Yes' : 'No' }}
                </span>
            </div>

            <div class="detail-field-item">
                <span class="field-label">Attendance Exempted</span>
                <span class="field-value">
                    {{ output1[0]?.is_attendance_exempted ? 'Yes' : 'No' }}
                </span>
            </div>
            <div class="detail-field-item">
                <span class="field-label">KYC Update Permission</span>
                <span class="field-value">
                    {{ output1[0]?.has_kyc_update_permission ? 'Yes' : 'No' }}
                </span>
            </div>

            <!-- Weekly Working Days — spans full width -->
            <div class="detail-field-item full-width">
                <span class="field-label">Weekly Working Days</span>
                <!-- NEW -->
                <div class="weekday-grid">
                    <div class="weekday-chip" *ngFor="let item of weeKDays">
                        <i class="fa-solid fa-check checked-icon" *ngIf="item.checked"></i>
                        <i class="fa-solid fa-xmark unchecked-icon" *ngIf="!item.checked"></i>
                        <span [class.active-day]="item.checked">{{ item.week }}</span>
                    </div>
                </div>
            </div>

        </div>

        <!-- Weekly Time Schedule Section -->
        <div class="classification-section" *ngIf="getFilteredWeeklySchedule().length">
            <div class="classification-header">
                <i class="fas fa-clock me-2"></i>
                Weekly Time Schedule
            </div>
            <div class="classification-body">
                <div class="table-responsive">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th>Day</th>
                                <th>Work In</th>
                                <th>Work Out</th>
                                <th>Lunch In</th>
                                <th>Lunch Out</th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr *ngFor="let sched of getFilteredWeeklySchedule()">
                                <td>{{ formatDayNumber(sched.day) }}</td>
                                <td>{{ sched.workin_time || '—' }}</td>
                                <td>{{ sched.workout_time || '—' }}</td>
                                <td>{{ sched.lunch_in_time || '—' }}</td>
                                <td>{{ sched.lunch_out_time || '—' }}</td>
                            </tr>
                        </tbody>
                    </table>
                </div>
            </div>
        </div>

        <!-- Customer Classification Section -->
        <div class="classification-section" *ngIf="userTypeDetails">

            <div class="classification-header">
                <i class="fas fa-users-cog me-2"></i>
                Customer Classification — {{ userTypeDetails?.name }}
            </div>

            <!-- Loading -->
            <div *ngIf="classificationLoading" class="text-center py-4">
                <i class="fas fa-spinner fa-spin fa-2x text-muted"></i>
                <p class="mt-2 text-muted">Loading classification data...</p>
            </div>

            <!-- Table -->
            <div class="classification-body"
                *ngIf="!classificationLoading && getFormattedClassificationData().length > 0">
                <div class="table-responsive">
                    <table class="custom-table">
                        <thead>
                            <tr>
                                <th style="width:30%">App Industry</th>
                                <th style="width:20%">Tier Name</th>
                                <th style="width:25%">From</th>
                                <th style="width:25%">To</th>
                            </tr>
                        </thead>
                        <tbody>
                            <ng-container *ngFor="let item of getFormattedClassificationData()">
                                <tr>
                                    <td *ngIf="item.isFirstRow" [attr.rowspan]="item.rowSpan" class="align-middle">
                                        <strong>{{ item.industryName }}</strong>
                                    </td>
                                    <td>
                                        <span class="tier-badge" [ngClass]="getTierBadgeClass(item.tierName)">
                                            <i [class]="getTierIconClass(item.tierName) + ' me-1'"></i>
                                            {{ item.tierName }}
                                        </span>
                                    </td>
                                    <td>{{ item.from | number }}</td>
                                    <td>{{ item.to | number }}</td>
                                </tr>
                            </ng-container>
                        </tbody>
                    </table>
                </div>

                <div class="summary-box">
                    <i class="fas fa-info-circle me-2"></i>
                    <strong>{{ userTypeDetails?.app_industry?.length || 0 }}</strong>
                    industr{{ (userTypeDetails?.app_industry?.length || 0) === 1 ? 'y' : 'ies' }} configured with
                    <strong>{{ getTotalTiersCount() }}</strong>
                    total tier{{ getTotalTiersCount() === 1 ? '' : 's' }}
                </div>
            </div>

            <!-- Empty State -->
            <div *ngIf="!classificationLoading && getFormattedClassificationData().length === 0"
                class="text-center py-4">
                <i class="fas fa-inbox fa-3x text-muted mb-3"></i>
                <p class="text-muted">No classification data available for this user type</p>
            </div>

        </div>

    </div>
</div>